//@import dependencies
import React, {useEffect, useState} from 'react'
import { ButtonGroup, ToggleButton } from 'react-bootstrap'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AlertComponent from 'app_components/commons/alert'
import MyCoursesSkeleton from './myCoursesSkeleton'
//@end

// @import hooks
// @end

// @INFO Import types
import {IMyCourse, IMyCourseTab} from 'app_types/campus/academic/myCoursesTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../myCoursesModule.scss'
import { CourseSchedulingStatus } from 'app_types/admin/courseScheduling/courseSchedulingTypes'

// @ADD Component types
interface IMyCoursesModuleLayoutProps {
  role?: string
  current_courses: Array<IMyCourse>
  history_courses: Array<IMyCourse>
  status: 'loading' | 'error' | null
  handleCourseSelectedChange: (course: IMyCourse) => void
  handleCourseTabChange: (tab: IMyCourseTab) => void
}

const MyCoursesModuleLayout: React.FC<IMyCoursesModuleLayoutProps> = (props) => {

  const [radioValue, setRadioValue] = useState('1')
  const [courseSelected, setCourseSelected] = useState<IMyCourse | null>(null)

  const { t } = useTranslation()

  const radios = [
    { name: t('modules.my_courses.section.current_courses'), value: '1' },
    { name: t('modules.my_courses.section.history_courses'), value: '2' },
  ]

  const onCourseSelected = (course: IMyCourse) => {
    setCourseSelected(course)
    props.handleCourseSelectedChange(course)
  }

  const onChangeTab = (value: any) => {
    setRadioValue(value)
    const tab = value === '1' ? IMyCourseTab.CURRENT_COURSES : IMyCourseTab.HISTORY_COURSES;
    props.handleCourseTabChange(tab)
  }

  useEffect(() => {
    if (props.current_courses && Array.isArray(props.current_courses) && props.current_courses.length > 0) {
      onChangeTab('1')
      onCourseSelected(props.current_courses[0])
    } else if (props.history_courses && Array.isArray(props.history_courses) && props.history_courses.length > 0) {
      onChangeTab('2')
      onCourseSelected(props.history_courses[0])
    }
  }, [props.current_courses, props.history_courses])

  useEffect(() => {
    onChangeTab('1')
  }, [])

  return(
    <div className='my_courses-component'>
      {props.status === 'loading' ? (
        <MyCoursesSkeleton />
      ) : (
        <>
          {
            (props.current_courses && Array.isArray(props.current_courses) && props.current_courses.length > 0) ||
            (props.history_courses && Array.isArray(props.history_courses) && props.history_courses.length > 0) ? (
              <>
                <div className={`my-courses-sections ${props?.role ? (props.role) : ''}`}>
                  <ButtonGroup toggle>
                    {radios.map((radio, idx) => (
                      <ToggleButton
                        key={idx}
                        type='radio'
                        variant='secondary'
                        name='radio'
                        value={radio.value}
                        checked={radioValue === radio.value}
                        onChange={(e) => onChangeTab(e.currentTarget.value)}
                      >
                        {radio.name}
                      </ToggleButton>
                    ))}
                  </ButtonGroup>
                </div>

                {radioValue === '1' && (
                  <>
                    {props.current_courses && Array.isArray(props.current_courses) && props.current_courses.length > 0 ? (
                      <div className={`list-courses ${props?.role ? (props.role) : ''}`}>
                        {props.current_courses.map((course) => (
                          <OverlayTrigger
                            key={`overlay_${course._id}`}
                            trigger={['hover', 'focus']}
                            placement={'right'}
                            overlay={
                              <Tooltip id='toolip-circle'>
                                <strong>{course.service_id}</strong><br/>{course.name}
                              </Tooltip>
                            }>
                            <button className={`btn btn-course ${(courseSelected?._id?.toString() === course._id.toString()) ? 'active' : ''}`} key={course._id} onClick={() => onCourseSelected(course)}>
                              {course.name}
                            </button>
                          </OverlayTrigger>
                        ))}
                      </div>
                    ) : (
                      <AlertComponent
                        type='warning'
                        title={t('modules.my_courses.current_courses.no_data')}
                      />
                    )}
                  </>
                )}
                {radioValue === '2' && (
                  <>
                    {props.history_courses && Array.isArray(props.history_courses) && props.history_courses.length > 0 ? (
                      <div className={`list-courses ${props?.role ? (props.role) : ''}`}>
                        {props.history_courses?.filter(register => register.schedulingStatus?.name !== CourseSchedulingStatus.CANCELED)?.map((course) => (
                          <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement={'right'}
                            overlay={
                              <Tooltip id='toolip-circle'>
                                <strong>{course.service_id}</strong><br/>{course.name}
                              </Tooltip>
                            }>
                            <button className={`btn btn-course ${(courseSelected?._id?.toString() === course._id.toString()) ? 'active' : ''}`} key={course._id} onClick={() => onCourseSelected(course)}>
                              {course.name}
                            </button>
                          </OverlayTrigger>
                        ))}
                      </div>
                    ) : (
                      <AlertComponent
                        type='warning'
                        title={t('modules.my_courses.history_courses.no_data')}
                      />
                    )}
                  </>
                )}
              </>
          ) : (
            <AlertComponent
              type='warning'
              title={t('modules.my_courses.no_data')}
            />
          )}
        </>
      )}
    </div>
  )
}

export default MyCoursesModuleLayout
